export const TITLESREPORT = (centro:any,año:any, periodo: any) => {
    return {
        TENDVEH: `${centro} - TENDENCIA DE CIERRE ${año}`,
        PROPOBJVEH: `${centro} - OBJETIVOS ${año}`,
        PROOBJTEND: `${centro} - PROPUESTA DE OBJETIVOS ${año+1}`,
        OBJREAL: `${centro} - OBJETIVOS ${año}`,
        TENDOBJ: `${centro} - TENDENCIA ${año}-CIERRE VS. OBJETIVO ANUAL ${año}`,
        GREVOL: `${centro} - GRAFICO EVOLUTIVO ${año}`,
        GRPRPOBJ: `${centro} - ${(periodo == 4 ? 'PROPUESTA DE ' : '')}OBJETIVOS ${año + (periodo == 4 ? 1 : 0)}`,
        GRTEND: `${centro} - TENDENCIA ${año}`
    }
}